import React from "react";
import SidePanelLayout from "layouts/SidePanelLayout";
import SwiftWiresFilter from "./SwiftWiresFilter";
import SwiftWiresPanel from "./SwiftWiresPanel";

export default function SwiftWiresList() {

    return (<>
        <SidePanelLayout
            sideComponent={SwiftWiresFilter}
            mainComponent={SwiftWiresPanel}>
        </SidePanelLayout>
    </>);

}
